import React from "react";
import { usePagSeguroContext } from "../context";

const OptionsInstallments = (props) => {
  const { installmentsArr, isLoadingInstallments } = usePagSeguroContext();

  return (
    <>
      {installmentsArr.length === 0 ? (
        <option disabled value={0}>
          {isLoadingInstallments
            ? "Carregando..."
            : "Primeiro informe o número do cartão"}
        </option>
      ) : (
        <>
          <option disabled value={0} selected>
            Selecione a quantidade de parcelas
          </option>
          {installmentsArr.map((installment) => (
            <option value={installment.quantity} key={installment.quantity}>
              {installment.quantity} x R${" "}
              {parseFloat(installment.installmentAmount).toFixed(2)} -{" "}
              {installment.interestFree ? "Sem" : "Com"} Juros
            </option>
          ))}
        </>
      )}
    </>
  );
};

export default OptionsInstallments;
